import { Navigate, useLocation } from "react-router-dom";
import { isAdminSession, loginPath } from "@/lib/adminAuth";

export const RequireAdmin = ({ children }) => {
  const location = useLocation();
  if (!isAdminSession()) {
    return <Navigate to={loginPath(location.pathname)} replace />;
  }
  return children;
};

export default RequireAdmin;
